import { render } from "./UploadIcon.vue?vue&type=template&id=416e75f0&ts=true"
import script from "./UploadIcon.vue?vue&type=script&lang=ts"
export * from "./UploadIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__